import { HtmlRenderer, Parser } from 'commonmark'

import * as React from 'react';
import { Link } from 'react-router';

import CertificateContentPage from '../../api/certificatesContentPageEntity';
import LinkItem from '../../api/linkItemEntity';

import { BreadcrumbContainer } from '../../common/components/breadcrumb/breadcrumbContainer';

interface IProps {
    certificateContentPage: CertificateContentPage;
    fetchCertificateContentPage(): void;
}

export class CertificatesPage extends React.Component<IProps,{}> {
  public componentDidMount() {
    this.props.fetchCertificateContentPage();
  }

  public render() {
    const page = this.props.certificateContentPage;

    // 1 — fast-exit while loading
    if (!page || !page.content) {
      return (
        <main className="contentpage is-loading">
          <div className="container">
            <BreadcrumbContainer />
            <p>Ladataan sisältöä…</p>
          </div>
        </main>
      );
    }

    // 2 — safe markdown parsing once content exists
    const parser = new Parser();
    const renderer = new HtmlRenderer();
    const content = renderer.render(parser.parse(page.content));
    const builderLinks = page.builderLinks || [];
    const professionalLinks = page.professionalLinks || [];
    const linkItems = page.linkItems || [];

    return (
        <main className="contentpage">
            <div className="container">

                <BreadcrumbContainer />

                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <div className="content">
                            <img src={page.heroImage} className="content-hero-img" />
                            <h1>{page.title}</h1>
                         
                            <p dangerouslySetInnerHTML={ {__html: content} } />
                        </div>
                        <br /><br />
                        <div className="certs">
                            <div className="row">
                                <div className="col-md-6 col-sm-12 ">
                                <h3>Asiantuntijat</h3>
                                    <ul className="listing">
                                        {builderLinks.map(LinkItemBlock)}
                                    </ul>
                                </div>
                                <div className="col-md-6 col-sm-12">
                                    <h3>Rakentajat</h3>
                                        <ul className="listing">
                                        {professionalLinks.map(LinkItemBlock)}
                                        </ul>
                                </div>
                            </div>
                            <div className="row link-blocks">{linkItems.slice(0, 3).map(LinkIBoxtemBlock)}</div>
                            <div className="row link-blocks">{linkItems.slice(3, 6).map(LinkIBoxtemBlock)}</div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
  }
};

const LinkIBoxtemBlock = (linkItem: LinkItem) => {

    if (linkItem.url.startsWith("http")) {
        return (
            <div className="col-md-4">
                <a href={linkItem.url} target={linkItem.urlTarget} className="link-block">
                    <h3>{linkItem.title}</h3>
                    <span>{linkItem.description}</span>
                </a>
            </div>
        )
    }
    
    return (
        <div className="col-md-4">
            <Link to={linkItem.url} className="link-block">
                <h3>{linkItem.title}</h3>
                <span>{linkItem.description}</span>
            </Link>
        </div>
    )
}

const LinkItemBlock = (linkItem: LinkItem) => {
    return (
        <li>
            <Link to={linkItem.url} target={linkItem.urlTarget} className="box-inner-wrap">{linkItem.title}</Link>
        </li>
    )
  }


// WEBPACK FOOTER //
// ./src/components/certificatesPage/certificatesPage.tsx